
import Vue from 'vue'
import { TweenLite, Elastic, Power2 } from 'gsap'
import $ from 'domtastic'
import { CustomEase } from '../../utils/CustomEase.js'
import { isMobile } from 'mobile-device-detect'
import { CSS2RGB } from '@/common/utils/colorUtils'
import { ProjectState } from '../../channel.types'
import { getStore } from '../../store/store'
import injectCSS from '@/common/utils/injectCSS'
import { VPopover } from 'v-tooltip'

import doneCheck from '@/apps/channel/assets/done_outline-24px.svg'

require('@/common/assets/alex-core-layout-flexbox.css')

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Example:
//
//  <hotspot
//    id="emojis_hotspot_A"
//    title="Click on an emoji!"
//    class="comment-blocks-b"
//    icons="lumi_laughing,lumi_love,lumi_shocked,lumi_angry"
//    type="emojis_block">
//  </hotspot>
//
//  id. string. required. the html id property for the outermost element of the outer-container of the ui element.
//
//  icons. string. required. A CSV list of emoticons. See here: https://app.lumiere.is/Static/emoji.html
//
//  title. string. optional. default is "". This is the title of the emoji box.
//
//  class. string. optional. default is null. You can pass in an extra css class that will be appended to the outer-container
//     of the ui element.
//
//  Custom CSS: Use the channel-wide CSS overrides in the lumiere-admin. Use the id of a particular element as the CSS selector.
//
//    #paragraph_hotspot {
//      background:#000066;
//      color:white;
//      border-radius:5px;
//    }
//
//  You can make this floatable with the following custom class in your css.
//
//    #paragraph_hotspot {
//      position: relative;
//      float: left;
//      width: 50%;
//      margin-right:10px;
//    }
//
//
//  You can also pass in the extra_ui_class, and then coordinate that with the channel-wide-css to alter the styles of multiple
//  CommentBlock instances at once.
//
//  More examples: To change the background of the comment block and then change the button color,
//  use these classes along with the extra_ui_class parameter "comment-blocks-b" for as many instances of CommentBlock as you like.
//
//  .comment-blocks-b {
//    background:#0066CC;
// `}
//
//  Additional css-classes that you can target this way:
//
//     .hs-emojis-block__emoji-box
//     .hs-emojis-block--font
//     .hs-emojis-block__ui
//
//
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default Vue.extend({
  props: {
    id: String,
    title: String,
    icons: String,
    submittedMessage: {
      default: 'Emoji sent!',
      type: String,
    },
  },
  data: () => {
    return {
      isThisAHeroActivity: false,
      msg: '',
      maxLength: 1000,
      store: getStore(),
      submittedWithError: false,
      showSentMessage: false,
      showPopover: true,
      errors: [],
      customEase: CustomEase.create(
        'custom',
        'M0,0 C0.126,0.382 0.288,1.632 0.446,1.78 0.638,1.96 0.818,1 1,1'
      ),
      afterSentTimer: null,
    }
  },

  components: {
    VPopover,
  },

  computed: {
    hasTitle() {
      return this.title && this.title != ''
    },
    emojisList() {
      let emojisCSV = this.icons

      try {
        if (emojisCSV) {
          let split = emojisCSV.split(',')
          let emojisList = []

          for (let i = 0; i < split.length; i++) {
            let dirty = split[i]
            let clean = dirty.trim()
            let emojiInfo = this.getEmojiDataWithName(clean)
            if (emojiInfo) {
              emojisList.push(emojiInfo)
            }
          }

          return emojisList
        } else {
          return this.emojisForActivity
        }
      } catch (error) {
        console.log(error)
      }
    },

    //with hero activities, we don't have the luxury of just going to vuex and asking the article_engagements section,
    //because no single hero activity is ever activated and therefore a single emoji list from the article_engagements simply
    //does not exist.
    emojisForActivity() {
      return this.isThisAHeroActivity
        ? this.heroEmojis
        : this.store.state.article_engagements.emojis.list
    },

    touchBasedUI() {
      return isMobile
    },
    loading() {
      return this.store.state.channel.article_engagements.article_loading
    },
  },

  methods: {
    //this will return objects like this:
    //{"emoji":"lumi_angry","url":"https://s3.amazonaws.com/media.app.lumiere.is/app/images/icons/lumi_angry.svg"}
    getEmojiDataWithName(name) {
      let emojis = this.emojisForActivity

      for (let i = 0; i < emojis.length; i++) {
        let emojiName = emojis[i].emoji
        if (emojiName == name) {
          return emojis[i]
        }
      }

      return null
    },

    handleClick(event) {
      //for hero-activities. We don't want the click to be interpreted as an opportunity to start the activity.
      event.stopPropagation()
      event.preventDefault()

      //if the user clicked an emoji icon we're going to record that engagement
      //and animate-out the UI.
      if (event.target && event.target.getAttribute('data-emoji')) {
        let emojiIndex = event.target.getAttribute('data-emoji-index')
        this.recordEmojiEngagement(emojiIndex, event.target)
      }
    },

    recordEmojiEngagement(emojiIndex, emojiImg) {
      let engagementInfo = this.emojisList[emojiIndex]
      let emojiBox = emojiImg.parentNode

      let emojiBoxNew = document.createElement('div')
      emojiBoxNew.style.transform = emojiBox.style.transform
      emojiBoxNew.setAttribute(
        'class',
        'al-abox hs-emojis-block__emoji-box-fader'
      )

      let emojiImageNew = document.createElement('img')
      emojiImageNew.setAttribute('src', engagementInfo['url'])
      emojiImageNew.setAttribute('name', engagementInfo['emoji'])

      emojiImageNew.setAttribute('class', 'hs-emojis-block__svg-wrap')

      emojiBoxNew.appendChild(emojiImageNew)

      emojiBox.appendChild(emojiBoxNew)

      //For near-future: working the interactions back into hero-activities.
      // if (this.isThisAHeroActivity) {
      //   this.store.dispatch('article_interaction_hero_activity', {
      //     hotspotId: this.id,
      //     hotspotValue: engagementInfo['emoji'],
      //     id: this.idForHeroActivity,
      //   })
      // } else {
      this.store.dispatch('article_interaction', {
        hotspotId: this.id,
        hotspotValue: engagementInfo['emoji'],
      })
      //}

      TweenLite.to(emojiBoxNew, 0.5, {
        scale: 2,
        opacity: 0,
        onComplete: () => {
          emojiBox.removeChild(emojiBoxNew)
        },
      })
    },
  },
})
